import React, { useMemo, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import ForceGraph2D from "react-force-graph-2d";
import classes from "./Error404.module.css";

const funnyTopics = [
  "Lost Packets",
  "404 Dimensions",
  "Quantum Tacos",
  "Cat Lawyers",
  "Infinite Pizza",
  "Unicorn Startups",
  "AI Overlords",
  "Flat Mars Society",
  "Cloud Surfing",
  "Banana Economics",
  "Dogecoin Philosophy",
  "Cosmic Burritos",
  "Penguin Politics",
  "Teleporting Sandwiches",
  "Holographic Cats",
  "Multiverse Donuts",
  "Banana Phones",
  "Punk Rock Unicorns",
  "Coffee-Powered AI",
  "Moonlight Debuggers",
  "Cheese-Based Currencies",
];

const Error404 = () => {
  const fgRef = useRef();

  const graphData = useMemo(() => {
    const nodes = funnyTopics.map((t, i) => ({ id: i, name: t }));
    const links = [];
    nodes.forEach((node) => {
      const numLinks = 2 + Math.floor(Math.random() * 3);
      for (let j = 0; j < numLinks; j++) {
        const target = Math.floor(Math.random() * nodes.length);
        if (target !== node.id) links.push({ source: node.id, target });
      }
    });
    return { nodes, links };
  }, []);

  useEffect(() => {
    if (fgRef.current) {
      setTimeout(() => {
        fgRef.current.zoomToFit(400, 50);
      }, 600);
    }
  }, [graphData]);

  return (
    <div className={classes.container}>
      <motion.h1
        className={classes.title}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        404 — Page Not Found 🚀
      </motion.h1>

      <motion.p
        className={classes.subtitle}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        Looks like this page drifted into the void of{" "}
        <span className={classes.highlight}>Quantum Tacos 🌮</span>.
      </motion.p>

      <div className={classes.graphWrapper}>
        <ForceGraph2D
          ref={fgRef}
          graphData={graphData}
          nodeCanvasObject={(node, ctx, globalScale) => {
            const label = node.name;
            const fontSize = 13 / globalScale;
            ctx.font = `${fontSize}px Sans-Serif`;
            ctx.fillStyle = "#222";
            ctx.textAlign = "center";
            ctx.fillText(label, node.x, node.y + 8);
          }}
          nodeRelSize={6}
          linkColor={() => "#ccc"}
          linkWidth={1}
          backgroundColor="#fdfdfd"
        />
      </div>

      <motion.a
        href="/"
        className={classes.homeBtn}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        ⬅ Back to Home
      </motion.a>
    </div>
  );
};

export default Error404;
